export * from './recovery-password.component';
export * from './recovery-password.module';
